import { Form, Button } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import InputComponent from "../../../../component/InputComponent";
import { templeRequest } from "../../../../request/AuthRequest";

export default function FAQForm({ onChange }) {
	return (
		<Form.List name="faqs">
			{(fields, { add, remove }) => (
				<>
					{fields.map(({ key, name, ...restField }) => (
						<div style={{ padding: '10px', border: "1px solid #e5e7eb", marginBottom: 8 }}>
							{/* Question */}
							<InputComponent
								required
								name={[name, "question"]}
								label="Question"
								placeholder="Enter Question"
								onChange={onChange}
								rules={templeRequest.faqQuestion}
							/>

							{/* Answer */}
							<InputComponent
								required
								type={'textarea'}
								name={[name, "answer"]}
								label="Answer"
								placeholder="Enter Answer"
								onChange={onChange}
								rules={templeRequest.faqAnswer}
							/>
							{/* Delete */}
							<Button
								danger
								icon={<DeleteOutlined />}
								onClick={() => { remove(name); onChange() }}
								style={{ alignSelf: "flex-end" }}
							>
								Remove FAQ
							</Button>
						</div>
						// </Space>
					))}

					{/* Add FAQ */}
					<Form.Item>
						<Button
							type="dashed"
							onClick={() => add({ question: "", answer: "" })}
							block
							icon={<PlusOutlined />}
						>
							Add FAQ
						</Button>
					</Form.Item>
				</>
			)}
		</Form.List>
	);
}
